import { el, setChildren } from 'redom';

import internalEventCodes from 'event-system/codes/internal';

import fileTypes from 'constants/file-types';

import { stringToSVG } from 'utilities';

import uploadIconString from 'assets/images/upload-icon.svg?raw';

import './index.scss';

const uploadIcon = stringToSVG(uploadIconString);

class UploadingDisplay {

  constructor() {

    this.el = el('.file-input-uploading-display', [
      el('ht-spinner', {
        size: 'small'
      })
    ]);

  }

  update() {}

}

class MiniFileInput {

  constructor(configuration) {

    this.application = configuration.application;
    this.uploader = configuration.uploader;
    this.acceptedTypes = configuration.acceptedTypes || [fileTypes.ANY];
    this.file = this.normalizeInputFile(configuration.value);
    this.onFile = configuration.onFile || function noop() {};
    this.onClear = configuration.onClear || function noop() {};
    this.onUploadStart = configuration.onUploadStart || function noop() {};
    this.onUploadEnd = configuration.onUploadEnd || function noop() {};
    this.rawFile = null;

    this.uploadingDisplay = new UploadingDisplay({});

    this.button = el('button.file-input-button', {
      type: 'button'
    }, {
      onclick: this.handleButtonClick.bind(this)
    }, uploadIcon.cloneNode(true));

    let className = 'mini-file-input-main';

    this.el = el('div', {
      class: className
    }, this.determineInitialChildren());

  }

  normalizeInputFile(value) {

    if (typeof value === 'object' && value !== null && typeof value.url === 'string') {
      return value;
    }

    return null;

  }

  determineInitialChildren() {

    return [
      this.button
    ];
  }

  handleClearButtonClick() {

    this.clear();

    this.onClear();

  }

  handleProgress(data) {

    let uploadedPercent = Math.floor(data.percent);

    this.uploadingDisplay.update({
      filename: this.rawFile.name,
      progress: uploadedPercent
    });

  }

  handleFileUploadComplete(files) {

    // If cancelled by user, nothing is needed to be done
    if (this.rawFile === null) {
      return;
    }

    const rawFile = this.rawFile;

    this.rawFile = null;
    this.file = files[0];

    this.onFile(this.file, rawFile);

    setChildren(this.el, [
      this.button
    ]);

    this.onUploadEnd(null, rawFile);

  }

  handleUploadError(error) {

    this.onUploadEnd(error);
    this.application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: 'Unable to upload file!',
      seconds: 5,
      type: 'error'
    });

  }

  async setRawFile(rawFile) {

    this.file = null;
    this.rawFile = rawFile;

    setChildren(this.el, [
      this.uploadingDisplay
    ]);

    this.uploadingDisplay.update({
      filename: this.rawFile.name,
      progress: 0
    });

    const request = await this.uploader(this.rawFile);

    this.onUploadStart();
    request.on('progress', this.handleProgress.bind(this));

    request.on('success', this.handleFileUploadComplete.bind(this));

    request.on('error', this.handleUploadError.bind(this));

  }

  async handleButtonClick() {

    const result = await this.application.domUtility.askFileByTypes(this.acceptedTypes);

    if (result.cancelled === true) {
      return;
    }

    await this.setRawFile(result.file);

  }

  clear() {

    this.rawFile = null;
    this.file = null;

    setChildren(this.el, [
      this.button
    ]);

  }

  update(configuration) {

    this.application = configuration.application;
    this.uploader = configuration.uploader;
    this.acceptedTypes = configuration.acceptedTypes || [fileTypes.ANY];
    this.file = this.normalizeInputFile(configuration.value);
    this.onFile = configuration.onFile || function noop() {};
    this.onClear = configuration.onClear || function noop() {};
    this.onUploadStart = configuration.onUploadStart || function noop() {};
    this.onUploadEnd = configuration.onUploadEnd || function noop() {};
    this.rawFile = null;

  }

}

export default MiniFileInput;